import { useMemo, useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import 'ag-grid-enterprise'
import {
  defaultColDef
} from '../../../../common/grid.js'
import AgGridCommonList from '../../../../common/ag-grid/AgGridCommonList.jsx'
import { getEventListColumns } from './EventListAgColumns.jsx'
import { getLocaleText } from '../../../../actions/datagrid.js'
import { InfoComponent } from '../../common/InfoComponent.jsx'
import styles from './EventList.module.css'

const getTranslatedEventType = (code, t) => {
  const numericCode = code.slice(0, -1)
  if (numericCode === '18') return t(code, { ns: 'absencecausecode' })
  return t(numericCode, { ns: 'absencecausecode' })
}

export const EventList = ({ integrationMode, mappings, onMappingChange }) => {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    i18n.loadNamespaces(['absencecausecode'])
  }, [i18n])

  // Transform and filter data based on integration setting
  const rowData = useMemo(() => {
    if (!mappings) return []
    return mappings
    // Show all mappings if NOINTEGRATION (user needs to configure), otherwise only active ones
      .filter(mapping => integrationMode === 'NOINTEGRATION' ? true : mapping.status)
      .map(mapping => ({
        ...mapping,
        eventTypeLabel: getTranslatedEventType(mapping.absenceType, t)
      }))
  }, [mappings, t, integrationMode])

  /** Handle cell edits */
  const onCellValueChanged = useCallback((params) => {
    const { data } = params
    const updatedMappings = mappings.map(item =>
      item.absenceType === data.absenceType ? { ...item, ...data } : item
    )
    onMappingChange(updatedMappings)
  }, [mappings, onMappingChange])

  const eventListColumns  = useMemo(() => {
    return getEventListColumns(integrationMode, t)
  }, [integrationMode, t])

  return (
    <div className={styles.container}>
      {integrationMode === 'PROCOUNTOR' && (
        <InfoComponent
          header={t('IntegrationEnabled', 'Integraatio käytössä: Finago Procountor')}
          body={
            <>
              {t('IntegrationBodyStart', 'Tapahtumia hallitaan ')}
              <a href='/organization/integrations' className={styles.infoLink}>
                {t('IntegrationBodyLink', 'integraation kautta')}
              </a>
              {t('IntegrationBodyEnd', '.')}
            </>
          }
        />
      )}
      <AgGridCommonList
        className={styles.gridContainer}
        columns={eventListColumns}
        rowData={rowData}
        defaultColDef={defaultColDef}
        getLocaleText={(params) => getLocaleText(t, params)}
        agGridProps={{
          enableCellTextSelection: true,
          stopEditingWhenCellsLoseFocus: true,
          onCellValueChanged
        }}
      />
    </div>
  )
}